import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { CustomWidthTooltip } from '../utils/customWidthToolTipUtil';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const ScoreCard = ({ title, high, medium, low }) => {
  const total = high + medium + low;
  
  // Define minimum and maximum widths for visual consistency
  const minWidth = 100;
  const maxWidth = 200  ;
  
  const getWidth = (value) => {
    const proportion = (value + 1) / total;
    const calculatedWidth = proportion * 300;
    return Math.max(minWidth, Math.min(maxWidth, calculatedWidth));
  };

  const toolTip = "This is the overall scoring of all events and threats being detected";

  return (
    <Card sx={{ minWidth: 256, maxWidth: 400, backgroundColor: 'transparent' }}>
      <CardContent sx={{ p: 2 }}>
        {/* Card Title */}
        <Typography variant="h5" sx={{ color: 'white', mb: 2, fontWeight: 'bold' }}>
          {title}
          <CustomWidthTooltip title={ toolTip } placement="top" dynamicWidth="250px" dyanmicHeight="25px" showPhen='true'>
              <HelpOutlineIcon sx={{ '&:hover': { cursor: 'pointer' }, ml: 2 }}/>
          </CustomWidthTooltip>
        </Typography>
        
        {/* Header Section - Category Labels */}
        <Box sx={{ display: 'flex', borderRadius: '4px 4px 0 0', overflow: 'hidden' }}>
          <Box
            sx={{
              backgroundColor: '#1976d2',
              width: `${getWidth(high)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              py: 1,
            }}
          >
            High
          </Box>
          <Box
            sx={{
              backgroundColor: '#1976d2',
              width: `${getWidth(medium)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              py: 1,
            }}
          >
            Medium
          </Box>
          <Box
            sx={{
              backgroundColor: '#1976d2',
              width: `${getWidth(low)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              py: 1,
            }}
          >
            Low
          </Box>
        </Box>
        
        {/* Values Section - Numerical Counts with Color Coding */}
        <Box sx={{ display: 'flex', height: 50, borderRadius: '0 0 4px 4px', overflow: 'hidden' }}>
          {/* High Severity - Red */}
          <Box
            sx={{
              backgroundColor: "#f44336",
              width: `${getWidth(high)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              borderTop: '1px solid white',
              borderBottom: '1px solid white',
            }}
          >
            {high}
          </Box>
          {/* Medium Severity - Orange */}
          <Box
            sx={{
              backgroundColor: "#ff9800",
              width: `${getWidth(medium)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              borderTop: '1px solid white',
              borderBottom: '1px solid white',
            }}
          >
            {medium}
          </Box>
          {/* Low Severity - Gray */}
          <Box
            sx={{
              backgroundColor: "#9e9e9e",
              width: `${getWidth(low)}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              borderTop: '1px solid white',
              borderBottom: '1px solid white',
            }}
          >
            {low}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ScoreCard;